import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import { slideData } from './data';
import { SliderContainer, SlideContent, SlideBackground, StyledBody } from './styles';
import { Headline } from '@Backlot-Cars/archie';

const AUTO_PLAY_DELAY_IN_MS = 8000;

const FeatureSlider = () => {
	const renderSlideContent = (slide) => {
		if (!slide.title || !slide.description) {
			return null;
		}

		return (
			<>
				<Headline size="H1" color="invert" bold padding={16}>
					{slide.title}
				</Headline>
				<StyledBody size="largest" color="invert" style={{ fontWeight: 300 }}>
					{slide.description}
				</StyledBody>
				{slide.highlightedText && (
					<StyledBody size="largest" color="invert" bold>
						{slide.highlightedText}
					</StyledBody>
				)}
			</>
		);
	};

	return (
		<SliderContainer>
			<Swiper
				modules={[Navigation, Pagination, Autoplay, EffectFade]}
				spaceBetween={0}
				slidesPerView={1}
				loop={true}
				effect="fade"
				fadeEffect={{ crossFade: true }}
				autoplay={{ delay: AUTO_PLAY_DELAY_IN_MS, disableOnInteraction: false, pauseOnMouseEnter: true }}
				pagination={{ clickable: true, dynamicBullets: false }}
				navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
				speed={800}
				className="feature-slider"
			>
				{slideData.map((slide) => (
					<SwiperSlide key={slide.id}>
						<SlideBackground image={slide.image} />
						<SlideContent>{renderSlideContent(slide)}</SlideContent>
					</SwiperSlide>
				))}
				<div className="swiper-button-next" />
				<div className="swiper-button-prev" />
			</Swiper>
		</SliderContainer>
	);
};

export default FeatureSlider;
